
<template>
  <div
    class="feature-card mb-5 p-4"
    :class="{ 'reverse-layout': index % 2 === 1 }"
  >
    <div class="feature-image-container">
      <img :src="imageUrl" :alt="title" class="feature-image" />
    </div>
    <div class="feature-content">
      <h3 class="feature-title">
        <i class="feature-icon" :class="['fa-solid', `fa-${icon}`]"></i>
        {{ title }}
      </h3>
      <p class="feature-description">{{ description }}</p>
      <div class="feature-cta" :class="{ 'align-left': index % 2 === 1 }">
        <button
          class="feature-button"
          data-bs-toggle="modal"
          data-bs-target="#trialModal"
        >
          <i class="fa-solid fa-rocket"></i
          >{{ $t("pp_services.buttons.freeTrial") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FeatureCard",
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
/* 颜色变量定义 */
$white: #ffffff;
$blue-600: #2563eb;
$blue-700: #1d4ed8;
$blue-200: #bfdbfe;
$gray-800: #1f2937;
$gray-600: #4b5563;
$gray-100: #f3f4f6;

/* 特性卡片容器 */
.feature-card {
  background-color: $white;
  border-radius: 0.75rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  /* 响应式布局 */
  @media (min-width: 768px) {
    flex-direction: row;

    &.reverse-layout {
      flex-direction: row-reverse;
    }
  }
}

.feature-image-container {
  width: 100%;
  height: 16rem;
  overflow: hidden;
  margin: 1rem;
  border-radius: 0.75rem;

  @media (min-width: 768px) {
    width: 50%;
    height: auto;
  }
}

.feature-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 18px;
  transition: transform 0.5s ease;

  &:hover {
    transform: scale(1.1);
  }
}

/* 内容区域 */
.feature-content {
  width: 100%;
  padding: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: 768px) {
    width: 50%;
  }

  @media (max-width: 767px) {
    padding: 2rem;
  }
}

.feature-title {
  font-size: 24px;
  font-weight: bold;
  color: $gray-800;
  margin-top: 12px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.feature-icon {
  font-size: 24px;
  color: $blue-600;
  margin-right: 10px;
}

.feature-description {
  color: $gray-600;
  line-height: 1.6;
}

.feature-cta {
  margin-top: auto;
  padding-top: 24px;
  display: flex;
  justify-content: flex-end;

  &.align-left {
    justify-content: flex-start;
  }
}

.feature-button {
  padding: 12px 24px;
  background-color: $blue-600;
  color: $white;
  border-radius: 8px;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: $blue-700;
  }

  i {
    margin-right: 8px;
  }
}
</style>
